export default __webpack_public_path__ + "static/media/bling_1.23ffdc58.mp4";